import AdminArticleFirestoreDictionary from "./adminArticleFirestoreDictionary";

export default function AdminArticlePetTags() {
  return (
    <AdminArticleFirestoreDictionary
      heading="Article pet tags"
      collectionName="articlePetTags"
    />
  );
}
